import type { FunctionComponent, HTMLAttributes } from 'react';

import { useModifiers } from '../../../styles/hooks/useModifiers';

import styles from './overlayLabel.module.css';

export interface LabelProps extends HTMLAttributes<HTMLSpanElement> {
  small?: boolean;
}

export const OverlayLabel: FunctionComponent<LabelProps> = ({ children, small, ...rest }) => {
  const mods = useModifiers(styles, 'overlayLabel', { small });

  return (
    <span className={`${styles.overlayLabel} ${mods}`} {...rest}>
      {children}
    </span>
  );
};
